import FactureRèglementInputLine from "./FactureRèglementInputLine";
import { FactureState, useFacture } from "../hooks/useFacture";

type FactureRèglementsCompProps = ReturnType<
  typeof useFacture
>["règlementsProps"] & {
  onOpenVentilations: (idx: number) => void;
  onDeleteRèglementLine: (idx: number) => void;
  règlements: FactureState["règlements"];
  linesIndexWithVentilations: { [key: number]: boolean };
  isLocked: boolean;
  structureLocked: boolean;
};

const FactureRèglementsComp = (props: FactureRèglementsCompProps) => {
  const {
    règlements,
    onSetRèglementItemValueAtIndex,
    onConditionnalyAddRèglementLine,
    onOpenVentilations,
  } = props;

  return (
    <div className="card mt-3">
      <div className="card-header">
        <span className="fs-4 pt-2">Règlements multiples </span>
        {props.isLocked && (
          <span className="badge text-bg-warning ms-3">
            Exercice verrouillé
          </span>
        )}
      </div>
      <div className="card-body">
        <form>
          {règlements.map((regl, idx) => {
            const isLineLocked = props.isLocked || regl.locked === true;
            return (
              <fieldset disabled={isLineLocked} key={regl.uuid}>
                {isLineLocked && !props.isLocked && (
                  <span className="badge text-bg-warning mb-2">
                    Règlement verrouillé
                  </span>
                )}
                <FactureRèglementInputLine
                  {...regl}
                  onChange={(item, value) =>
                    onSetRèglementItemValueAtIndex(idx, item, value)
                  }
                  onVentilationClick={() => onOpenVentilations(idx)}
                  onDeleteRèglement={() => props.onDeleteRèglementLine(idx)}
                  onLineType={() => onConditionnalyAddRèglementLine(idx)}
                  hasVentilations={!!props.linesIndexWithVentilations[idx]}
                  structureLocked={props.structureLocked}
                />
              </fieldset>
            );
          })}
        </form>
      </div>
    </div>
  );
};

export default FactureRèglementsComp;
